interface ProportionBarProps {
    yesCount: number;
    noCount: number;
    className?: string;
}

function ProportionBar({ yesCount, noCount, className = "w-28 h-5" }: ProportionBarProps) {
    const n = yesCount + noCount;
    if (n === 0) {
        return <span className="text-muted-foreground text-xs">-</span>;
    }

    const yesPct = (yesCount / n) * 100;
    const noPct = 100 - yesPct;

    return (
        <div className={className}>
            <div className="flex rounded-full w-full h-full overflow-hidden">
                {yesPct > 0 && (
                    <div
                        className="flex justify-center items-center h-full font-medium text-[9px] text-white"
                        style={{
                            width: `${yesPct}%`,
                            backgroundColor: "hsl(var(--chart-1))",
                            minWidth: yesPct > 0 && yesPct < 12 ? "12px" : undefined,
                        }}
                    >
                        {yesPct >= 18 ? `${Math.round(yesPct)}%` : ""}
                    </div>
                )}
                {noPct > 0 && (
                    <div
                        className="flex justify-center items-center h-full font-medium text-[9px]"
                        style={{
                            width: `${noPct}%`,
                            backgroundColor: "hsl(var(--muted))",
                            color: "hsl(var(--muted-foreground))",
                            minWidth: noPct > 0 && noPct < 12 ? "12px" : undefined,
                        }}
                    >
                        {noPct >= 18 ? `${Math.round(noPct)}%` : ""}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProportionBar;
